<div class="event-container flex flex-column">
  <app-event-details [selectedEvent]="selectedEvent" [selectedEventAction]="selectedEventAction" class="w-100"></app-event-details>

  <div class="event-content w-100" [ngClass]="{ 'event-content-loading': !showSvg && !showSectorsView }">
    <div class="w-48">
      <div class="event-buttons-container" *ngIf="showSvg || showSectorsView">
        <button (click)="changeEventSectorsView('venue')" [classList]="!showSectorsView && 'active'">{{ "EVENT.SHOW_VENUE" | translate }}</button>
        <button (click)="changeEventSectorsView('sectors')" [classList]="showSectorsView && 'active'">{{ "EVENT.SECOTORS_WITH_PRICE" | translate }}</button>
      </div>

      <p class="venue-text mt-5" *ngIf="showSvg || showSectorsView">{{ "EVENT.SELECT_BLUE_BUTTON" | translate }}</p>

      <div class="seats-colors-legend mt-5 mb-3">
        <div class="seat-color-item" *ngIf="showLegendMembers">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="8" fill="#DAA400"/>
          </svg>
          <span class="venue-text gray">{{ "EVENT.FOR_MEMBERS" | translate }}</span>
        </div>
        <div class="seat-color-item" *ngIf="showLegendAvailable">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7.5" fill="#02A0FE" stroke="#1C88C2"/>
          </svg>
          <span class="venue-text gray">{{ "EVENT.FOR_ALL" | translate }}</span>
        </div>
        <div class="seat-color-item" *ngIf="showLegendUnavailable && !showSectorsView">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="8" fill="#D9D9D9"/>
          </svg>
          <span class="venue-text gray">{{ "EVENT.NOT_AVAILABLE" | translate }}</span>
        </div>
      </div>

      <div class="venue" *ngIf="showSvg && !showSectorsView">
        <svg [attr.viewBox]="svg?.svgViewbox || '80 310 380 300'" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="misc" [innerHTML]="miscInnerHtml"></g>
          <g id="stage" [innerHTML]="stageInnerHtml"></g>
          <g *ngFor="let path of svg?.sectors">
            <path
              style="display:inline;fill-opacity:1;fill-rule:evenodd;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
              [attr.d]="path.svgPath"
              [attr.id]="path.id"
              (click)="path.active && openAccordionFromSvg(path.id, path)"
              [ngClass]="{
                'inactive-path' : path.active === false,
                'active-path' : path.active === true && !memberExclusiveMap[path.id],
                'active-members-path': path.active === true && memberExclusiveMap[path.id],
              }"
            >
            </path>

            <text
              *ngIf="path.active"
              [attr.x]="path.textXPos"
              [attr.y]="path.textYPos"
              dominant-baseline="middle"
              dy="-0.43em"
              style="font-size:10px; font-weight:400; font-family:Open Sans, sans-serif; fill:#fff; pointer-events:none; text-anchor: middle;"
              [ngClass]="{'inactive-path' : path.active === false}">
              {{ path.nameShort }}
            </text>
          </g>
        </svg>
      </div>

      <div *ngIf="showSectorsView">
        <div *ngFor="let group of groups">
          <div class="sector-group" *ngIf="group?.sectors?.length > 0">
            <h3 class="mb-2">{{ group.name }}</h3>

            <div class="sector-list">
              <button
                *ngFor="let sector of group.sectors"
                [ngClass]="{
                  'sector-item': true,
                  'sector-item-members-exclusive': memberExclusiveMap[sector.id]
                }"
                (click)="openAccordionFromSvg(sector.id, sector)"
              >
                <div class="sector-name">{{ sector.name }}</div>
                <div class="sector-price">
                  <ng-container *ngFor="let price of sector.priceList.amounts">
                    <ng-container *ngIf="price !== 0 && price !== null">
                      <span *ngIf="price !== sector.priceList.amounts[0]">, </span>
                    </ng-container>
                    <span class="bold">{{ price }}</span>
                  </ng-container>
                  {{ sector.priceList.label }}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cart-and-payment-container" #cart *ngIf="cart !== null && (cart?.items?.length ?? 0) > 0 && event.event.id; else emptyCart">
      <app-users-form-fields
        *ngIf="customerProfile"
        [formFieldsKey]="formFieldsKey"
        (emptyCartEvent)="setEmptyCart()"
        (changeShowPaymentEvent)="changeShowPayment($event)"
        [customerProfile]="customerProfile"
        [event]="event"
        [hasPayment]="hasPayment"
        [orderId]="orderId">
      </app-users-form-fields>
      <app-payment
        *ngIf="showPayment"
        [cart]="cart"
        [orderId]="orderId"
        [hasPayment]="hasPayment"
        [orderInfo]=""
        [customerProfile]="customerProfile"
        [redirectUrlFromParent]="redirectUrlFromParent"
        [redirectErrorUrlFromParent]="redirectErrorUrlFromParent">
      </app-payment>
    </div>

    <ng-template #emptyCart>
      <div class="empty-cart" *ngIf="cartIsLoaded">
        <p class="empty-cart-subtitle mt-5-m">{{ "CART.CART" | translate }}:</p>
        <p>{{ "CART.EMPTY" | translate }}</p>
      </div>
    </ng-template>
  </div>

  <ng-container *ngTemplateOutlet="seatsTemplate"></ng-container>
</div>

<ng-template #seatsTemplate>
  <section id="seat-map-selection-tickets-container" *ngIf="seats && showSeats && isSeatMapSelectionTicketsModalOpen()">
    <div  class="modal modal-container" (mousedown)="modalService.closeModal(modalNamesEnum.SeatMapSelectionTickets)" id="seats" *ngIf="viewBox">
      <div class="modal-content" (mousedown)="$event.stopPropagation()">
        <div class="modal-body">
          <button type="button" class="close-button" (click)="closeSeats()">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 17 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.79287 8.6478L1 1.85493L1.70711 1.14783L8.49997 7.94069L15.2928 1.14783L15.9999 1.85493L9.20708 8.6478L15.4982 14.9389L14.7911 15.646L8.49997 9.35491L2.20887 15.646L1.50176 14.9389L7.79287 8.6478Z" fill="#797979"/>
              <path d="M1 1.85493L0.823223 1.67816C0.776339 1.72504 0.75 1.78863 0.75 1.85493C0.75 1.92124 0.776339 1.98483 0.823223 2.03171L1 1.85493ZM7.79287 8.6478L7.96964 8.82458C8.01653 8.77769 8.04287 8.7141 8.04287 8.6478C8.04287 8.5815 8.01653 8.51791 7.96964 8.47102L7.79287 8.6478ZM1.70711 1.14783L1.88388 0.97105C1.78625 0.873419 1.62796 0.873419 1.53033 0.97105L1.70711 1.14783ZM8.49997 7.94069L8.3232 8.11747C8.42083 8.2151 8.57912 8.2151 8.67675 8.11747L8.49997 7.94069ZM15.2928 1.14783L15.4696 0.97105C15.372 0.873419 15.2137 0.873419 15.1161 0.97105L15.2928 1.14783ZM15.9999 1.85493L16.1767 2.03171C16.2236 1.98483 16.2499 1.92124 16.2499 1.85493C16.2499 1.78863 16.2236 1.72504 16.1767 1.67816L15.9999 1.85493ZM9.20708 8.6478L9.0303 8.47102C8.93267 8.56865 8.93267 8.72694 9.0303 8.82458L9.20708 8.6478ZM15.4982 14.9389L15.675 15.1157C15.7726 15.0181 15.7726 14.8598 15.675 14.7621L15.4982 14.9389ZM14.7911 15.646L14.6143 15.8228C14.7119 15.9204 14.8702 15.9204 14.9679 15.8228L14.7911 15.646ZM8.49997 9.35491L8.67675 9.17813C8.57912 9.0805 8.42083 9.0805 8.3232 9.17813L8.49997 9.35491ZM2.20887 15.646L2.03209 15.8228C2.12972 15.9204 2.28801 15.9204 2.38564 15.8228L2.20887 15.646ZM1.50176 14.9389L1.32498 14.7621C1.2781 14.809 1.25176 14.8726 1.25176 14.9389C1.25176 15.0052 1.2781 15.0688 1.32498 15.1157L1.50176 14.9389ZM0.823223 2.03171L7.61609 8.82458L7.96964 8.47102L1.17678 1.67816L0.823223 2.03171ZM1.53033 0.97105L0.823223 1.67816L1.17678 2.03171L1.88388 1.3246L1.53033 0.97105ZM8.67675 7.76392L1.88388 0.97105L1.53033 1.3246L8.3232 8.11747L8.67675 7.76392ZM8.67675 8.11747L15.4696 1.3246L15.1161 0.97105L8.3232 7.76392L8.67675 8.11747ZM15.1161 1.3246L15.8232 2.03171L16.1767 1.67816L15.4696 0.97105L15.1161 1.3246ZM15.8232 1.67816L9.0303 8.47102L9.38386 8.82458L16.1767 2.03171L15.8232 1.67816ZM15.675 14.7621L9.38386 8.47102L9.0303 8.82458L15.3214 15.1157L15.675 14.7621ZM14.9679 15.8228L15.675 15.1157L15.3214 14.7621L14.6143 15.4692L14.9679 15.8228ZM8.3232 9.53168L14.6143 15.8228L14.9679 15.4692L8.67675 9.17813L8.3232 9.53168ZM8.3232 9.17813L2.03209 15.4692L2.38564 15.8228L8.67675 9.53168L8.3232 9.17813ZM2.38564 15.4692L1.67853 14.7621L1.32498 15.1157L2.03209 15.8228L2.38564 15.4692ZM1.67853 15.1157L7.96964 8.82458L7.61609 8.47102L1.32498 14.7621L1.67853 15.1157Z" fill="#797979"/>
            </svg>
          </button>

          <h3 class="seat-container-info-msg">{{ "EVENT.SELECTED_SECTOR" | translate }} <b>{{ sector.name }}</b></h3>
          <p class="info-text">{{ "EVENT.ZOOM_CONTROL_INFO" | translate }}</p>

          <div class="seat-row-wrapper">
            <div class="seats-colors-legend" *ngIf="!ifSeatsAreLoading">
              <ng-container *ngFor="let price of seatsPrice">
                <div class="seat-color-item">
                  <div class="seat-color" [ngStyle]="{ 'background-color': price.color }"></div>
                  <p>
                    {{ price.price }} {{ price.currency }}
                    <ng-container *ngIf="pricesForMembers">(
                      <ng-container *ngFor="let memberPrice of pricesForMembers; let i = index">
                        <ng-container *ngIf="memberPrice.cksId === price.cksId">
                          <ng-container *ngIf="i !== 0">, </ng-container>
                          <span class="member-price">{{ memberPrice.discountName }}: {{ memberPrice.price }} {{ price.currency }}</span>
                        </ng-container>
                      </ng-container>)
                    </ng-container>
                  </p>
                </div>
              </ng-container>

              <div class="seat-color-item">
                <div class="seat-color selected-seat"></div>
                <span>{{ "EVENT.SEATS.SELECTED" | translate }}</span>
              </div>

              <div class="seat-color-item">
                <div class="seat-color occupied"></div>
                <span>{{ "EVENT.SEATS.OCCUPIED" | translate }}</span>
              </div>
            </div>

            <div class="seat-svg-container">
              <div class="svg-controls" *ngIf="!ifSeatsAreLoading">
                <button class="zoom-button" (click)="zoomOut()" *ngIf="svgPanZoomService.isZoomed" >
                  <img src="img/icons/zoom-out-2.svg" />
                </button>
                <button
                *ngIf="svgPanZoomService.isZoomed"
                (click)="resetZoom()"
                class="zoom-button"
                >
                <img src="img/icons/zoom-reset-2.svg" />
              </button>
              <button class="zoom-button" (click)="zoomIn()">
                <img src="img/icons/zoom-in-2.svg" />
              </button>
              </div>

              <div #panzoomContainer class="panzoom-container">
                <svg
                  *ngIf="viewBox"
                  #svgElement
                  width="100%"
                  height="100%"
                  [attr.viewBox]="viewBox"
                  preserveAspectRatio="xMinYMin meet"
                  class="seats-clickable-svg"
                  (wheel)="onWheel($event)"
                  (mousedown)="startPan($event)"
                  (mousemove)="pan($event)"
                  (mouseup)="stopPan()"
                  (mouseleave)="stopPan()"
                  (touchstart)="handleTouchStart($event)"
                  (touchmove)="handleTouchMove($event)"
                  (touchend)="handleTouchEnd($event)"
                  >
                  <ng-container *ngFor="let seat of seats.seats; let i = index">
                    <ng-container *ngIf="i === 0 || seat.row !== seats.seats[i - 1].row">
                      <text
                        [attr.x]="seat.x * 30 - 5"
                        [attr.y]="seat.y * 30 - 5"
                        dominant-baseline="middle"
                        text-anchor="middle"
                        fill="#000"
                        style="pointer-events: none;"
                      >{{ seat.row }}</text>
                    </ng-container>
                    <circle
                      class="seat"
                      [attr.cx]="seat.x * 30 + 20"
                      [attr.cy]="seat.y * 30 - 5"
                      r="15"
                      [id]="seat.rstu"
                      [ngClass]="{ 'occupied': !seat.isFree }"
                      (mouseup)="seat.isFree && selectSeat(seat, $event)"
                      pointer-events="visible"
                      [attr.fill]="seat.color"
                      [attr.data-row]="seat.row"
                      [attr.data-seat]="seat.seat"
                      [attr.data-rstu]="seat.rstu"
                    ></circle>
                    <text
                      [attr.x]="seat.x * 30 - 5 + 25"
                      [attr.y]="seat.y * 30 - 5"
                      dominant-baseline="middle"
                      text-anchor="middle"
                      fill="white"
                      style="pointer-events: none;"
                    >{{ seat.seat }}</text>
                  </ng-container>
                </svg>
              </div>
            </div>
          </div>
          <p *ngIf="infoMessageSeats" class="error-message-seats">{{ infoMessageSeats }}</p>
          <p *ngIf="isTransactionLocked()" class="error-message-seats">{{ "EVENT.SEATS.ALREADY_LOCKED" | translate }}</p>

          <div class="button-container">
            <button class="btn btn-primary" *ngIf="selectedSeats.length > 0 && !isTransactionLocked()" (click)="addToCartNumbered()">{{ "CART.ADD" | translate }}</button>
          </div>

          <ng-container *ngIf="ifSeatsAreLoading">
            <app-loader></app-loader>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
</ng-template>

<section id="auto-selection-tickets-container" *ngIf="isAutoSelectionTicketsModalOpen()">
  <div class="modal modal-container" (mousedown)="modalService.closeModal(modalNamesEnum.AutoSelectionTickets)">
    <div class="modal-content" (mousedown)="$event.stopPropagation()">
      <button type="button" class="btn-close" (click)="modalService.closeModal(modalNamesEnum.AutoSelectionTickets)" [attr.title]="'COMMON.CLOSE' | translate" [attr.aria-label]="'LOGIN.CLOSE_ARIA' | translate">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 17 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.79287 8.6478L1 1.85493L1.70711 1.14783L8.49997 7.94069L15.2928 1.14783L15.9999 1.85493L9.20708 8.6478L15.4982 14.9389L14.7911 15.646L8.49997 9.35491L2.20887 15.646L1.50176 14.9389L7.79287 8.6478Z" fill="#797979"/>
          <path d="M1 1.85493L0.823223 1.67816C0.776339 1.72504 0.75 1.78863 0.75 1.85493C0.75 1.92124 0.776339 1.98483 0.823223 2.03171L1 1.85493ZM7.79287 8.6478L7.96964 8.82458C8.01653 8.77769 8.04287 8.7141 8.04287 8.6478C8.04287 8.5815 8.01653 8.51791 7.96964 8.47102L7.79287 8.6478ZM1.70711 1.14783L1.88388 0.97105C1.78625 0.873419 1.62796 0.873419 1.53033 0.97105L1.70711 1.14783ZM8.49997 7.94069L8.3232 8.11747C8.42083 8.2151 8.57912 8.2151 8.67675 8.11747L8.49997 7.94069ZM15.2928 1.14783L15.4696 0.97105C15.372 0.873419 15.2137 0.873419 15.1161 0.97105L15.2928 1.14783ZM15.9999 1.85493L16.1767 2.03171C16.2236 1.98483 16.2499 1.92124 16.2499 1.85493C16.2499 1.78863 16.2236 1.72504 16.1767 1.67816L15.9999 1.85493ZM9.20708 8.6478L9.0303 8.47102C8.93267 8.56865 8.93267 8.72694 9.0303 8.82458L9.20708 8.6478ZM15.4982 14.9389L15.675 15.1157C15.7726 15.0181 15.7726 14.8598 15.675 14.7621L15.4982 14.9389ZM14.7911 15.646L14.6143 15.8228C14.7119 15.9204 14.8702 15.9204 14.9679 15.8228L14.7911 15.646ZM8.49997 9.35491L8.67675 9.17813C8.57912 9.0805 8.42083 9.0805 8.3232 9.17813L8.49997 9.35491ZM2.20887 15.646L2.03209 15.8228C2.12972 15.9204 2.28801 15.9204 2.38564 15.8228L2.20887 15.646ZM1.50176 14.9389L1.32498 14.7621C1.2781 14.809 1.25176 14.8726 1.25176 14.9389C1.25176 15.0052 1.2781 15.0688 1.32498 15.1157L1.50176 14.9389ZM0.823223 2.03171L7.61609 8.82458L7.96964 8.47102L1.17678 1.67816L0.823223 2.03171ZM1.53033 0.97105L0.823223 1.67816L1.17678 2.03171L1.88388 1.3246L1.53033 0.97105ZM8.67675 7.76392L1.88388 0.97105L1.53033 1.3246L8.3232 8.11747L8.67675 7.76392ZM8.67675 8.11747L15.4696 1.3246L15.1161 0.97105L8.3232 7.76392L8.67675 8.11747ZM15.1161 1.3246L15.8232 2.03171L16.1767 1.67816L15.4696 0.97105L15.1161 1.3246ZM15.8232 1.67816L9.0303 8.47102L9.38386 8.82458L16.1767 2.03171L15.8232 1.67816ZM15.675 14.7621L9.38386 8.47102L9.0303 8.82458L15.3214 15.1157L15.675 14.7621ZM14.9679 15.8228L15.675 15.1157L15.3214 14.7621L14.6143 15.4692L14.9679 15.8228ZM8.3232 9.53168L14.6143 15.8228L14.9679 15.4692L8.67675 9.17813L8.3232 9.53168ZM8.3232 9.17813L2.03209 15.4692L2.38564 15.8228L8.67675 9.53168L8.3232 9.17813ZM2.38564 15.4692L1.67853 14.7621L1.32498 15.1157L2.03209 15.8228L2.38564 15.4692ZM1.67853 15.1157L7.96964 8.82458L7.61609 8.47102L1.32498 14.7621L1.67853 15.1157Z" fill="#797979"/>
        </svg>
      </button>

      <div class="modal-body">
        <h3 class="form-title">{{ "EVENT.SELECTED_SECTOR" | translate }} {{ selectedSector }}</h3>

        <div class="counter">
          <span class="mr-6">{{ "EVENT.TICKETS_NUMBER" | translate }}:</span>
          <button (click)="calculatePriceFromModal('-')">-</button>
          <input type="number" value="1" id="ticket-number-modal" disabled/>
          <button (click)="calculatePriceFromModal('+')">+</button>
        </div>

        <p *ngIf="errorMessage" class="error-message mb-5">{{ errorMessage }}</p>
          <p *ngIf="isTransactionLocked()" class="error-message-seats">{{ "EVENT.SEATS.ALREADY_LOCKED" | translate }}</p>

        <button
          class="btn btn-primary"
          (click)="addToCart(selectedSectorAll.group.id, selectedSectorAll.id, selectedSectorAll.id, false)"
          *ngIf="!isTransactionLocked()"
          >{{ "CART.ADD" | translate }}</button>
      </div>
    </div>
  </div>
</section>

<app-notification *ngIf="showNotification" [bodyText]="bodyText | translate"></app-notification>
